import { render, staticRenderFns } from "./SwiperBanner.vue?vue&type=template&id=6e9a6af2"
import script from "./SwiperBanner.vue?vue&type=script&lang=js"
export * from "./SwiperBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports